import { Component, computed, input, linkedSignal } from '@angular/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ClTooltip } from '@corelabs/angular/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { LiveStatus } from '@shared/models';

/** Pinned to a box whose numbers follow the floor; renders nothing while `status` is null. */
@Component({
    selector: 'app-live',
    templateUrl: './live.component.html',
    styleUrl: './live.component.css',
    imports: [TranslatePipe, ClTooltip],
})
export class LiveComponent {
    readonly status = input.required<LiveStatus>();
    /** The box's live data — every new value ripples the dot once. */
    readonly data = input.required<unknown>();

    protected readonly copy = computed(() =>
        this.status() === 'live'
            ? { label: marker('common.live.label'), hint: marker('common.live.on') }
            : { label: marker('common.live.reconnecting-label'), hint: marker('common.live.reconnecting') },
    );

    // counts the values that landed, so the ripple replays on each one
    protected readonly updates = linkedSignal<unknown, number>({
        source: this.data,
        computation: (_, previous) => (previous?.value ?? 0) + 1,
    });
}
